import { useState, useEffect } from "react";

import { Description } from "@mui/icons-material";
import Loader from "base/components/Loader";
import MenuList from "./MenuList";

import { getMainRoutes, getSettingRoutes } from "./nav-routes";
import { LinkType } from "types/menu";
import {
  MANUSCRIPT_NOVEL_URL,
  MANUSCRIPT_BOOK_URL,
  MANUSCRIPT_NOVEL_ROUTE_FACTOR,
  MANUSCRIPT_BOOK_ROUTE_FACTOR,
} from "manuscript/constants/route";
import { MenuItemType, MenuType } from "types/config";

import { useRecoilValue } from "recoil";
import { configState } from "base/store/config";
import { Box } from "@mui/material";
import { MANUSCRIPT_LIST_URL } from "manuscript/constants/route";
import { useTranslation } from "react-i18next";

const initMenuFromAPI = (menu: MenuType) => {
  return {
    text: menu.name,
    href: menu.type === 1 ? MANUSCRIPT_BOOK_URL : MANUSCRIPT_NOVEL_URL,
    icon: Description,
    isExpand: true,
  };
};

const createAdditionalMenu = (rows: MenuItemType[]): LinkType[] => {
  return rows.map((item) => ({
    text: item.name,
    href: `${MANUSCRIPT_LIST_URL}/${
      item.type == 1
        ? MANUSCRIPT_BOOK_ROUTE_FACTOR
        : MANUSCRIPT_NOVEL_ROUTE_FACTOR
    }/${item.id}`,
    icon: Description,
    isExpand: false,
    subLinks: undefined,
  }));
};

const LeftMenu = () => {
  const { i18n } = useTranslation();

  // Recoil
  const { admin, isLoadingConfig, menu } = useRecoilValue(configState);

  // State
  const [menus, setMenus] = useState<LinkType[]>([]);

  useEffect(() => {
    let newMenus: LinkType[] = getMainRoutes();

    if (admin) {
      newMenus.push(getSettingRoutes());
    }

    if (menu) {
      // We hardcode it because we only have two types
      const menuType1: MenuType = menu[0];
      const menuType2: MenuType = menu[1];
      const menuItemAll = newMenus[1]?.subLinks?.[1] as LinkType;

      // Init type 1 and type 2 categories
      menuItemAll.subLinks = []; // Reset reference to make MenuList re-render
      menuItemAll.subLinks?.push(initMenuFromAPI(menuType1));
      menuItemAll.subLinks?.push(initMenuFromAPI(menuType2));

      // Create additional categories
      const additionalMenuType1: LinkType[] = createAdditionalMenu(
        menuType1.rows
      );
      const additionalMenuType2: LinkType[] = createAdditionalMenu(
        menuType2.rows
      );

      // Recursively check and add additional categories to corresponding menu
      processRoutes(newMenus, additionalMenuType1, additionalMenuType2);
    }

    setMenus(newMenus);
  }, [menu, i18n.language, admin]);

  /**
   * Add additional manuscript categories
   */
  function processRoutes(
    links: LinkType[] | undefined,
    menusType1: LinkType[],
    menusType2: LinkType[]
  ) {
    if (!links) {
      return;
    }

    for (const link of links) {
      if (link.href === MANUSCRIPT_BOOK_URL) {
        link.subLinks = menusType1;
      }
      if (link.href === MANUSCRIPT_NOVEL_URL) {
        link.subLinks = menusType2;
      }

      processRoutes(link.subLinks, menusType1, menusType2);
    }
  }

  return (
    <Box sx={{ height: "100%" }}>
      {isLoadingConfig ? <Loader /> : <MenuList links={menus} level={0} />}
    </Box>
  );
};

export default LeftMenu;
